import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import helpCenterUrl from 'modules/core/lib/helpCenterUrl'
import i18n from 'modules/core/lib/i18n'

const HelpCenter = () => {
  return (
    <Box
      width="full"
      border={{
        all: {
          color: 'grey400',
          width: 's1',
          style: 'solid',
        },
      }}
      borderRadius={{
        all: 'abs008',
      }}
      padding="s32"
      gap="s24"
    >
      <Text.Header2 color="grey800">
        {i18n.t('settings.permissions.group.help_center.title')}
      </Text.Header2>
      <Text.Normal>{i18n.t('settings.permissions.group.help_center.description')}</Text.Normal>
      <Button.Router to={helpCenterUrl('permissions')} type="primary" blankTarget>
        {i18n.t('settings.permissions.group.help_center.action')}
      </Button.Router>
    </Box>
  )
}

export default observer(HelpCenter)
